import styled from 'styled-components';

export const Logo = styled.div`
  display: flex;
  align-items: center;
`;

export const Copy = styled.div`
  margin-left: 13px;
`;
